export const RECAPTCHA_ACTION = {
  CHECK_IN: "CHECK_IN",
  MMB: "MANAGE_MY_BOOKING",
  RESET_PASSWORD: "RESET_PASSWORD",
};

export const recaptchaDetect = {
  mmbBot: "recaptcha_bot_detected_mmb",
  checkInBot: "recaptcha_bot_detected_check_in",
};

export const recaptchaMessage = "Captcha could not be loaded";
